import React, { Component } from 'react';

class Video extends Component {
	render() {
		return (
			<div>
				<h1 className="video__heading">
					SMOOTH and LUXURIOUS SKIN <br />- a truly CLEAN SLATE
				</h1>
				<section className="video">
					<div className="video-tag">
						<div className="c-video"></div>
					</div>
				</section>
			</div>
		);
	}
}


export default Video;